;(function($) {
  var templateUrl = object_name.templateUrl
  var liveIconUrl = templateUrl + '/assets/images/map/pin01.png'
  var soonIconUrl = templateUrl + '/assets/images/map/pin02.png'
  var clusterIconUrl = templateUrl + '/assets/images/map/pin03.png'
  var clusterer
  /**
   * initMap
   *
   * Renders a Google Map onto the selected jQuery element
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @return  object The map instance.
   */
  function initMap($el, isFilter = false) {
    // Find marker elements within map.
    var $markers = $el.find('.marker')

    // Create generic map.
    var mapArgs = {
      zoom: $el.data('zoom') || 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    }
    var map = new google.maps.Map($el[0], mapArgs)

    // Add HTML markers
    function HTMLMarker(lat, lng, html) {
      this.lat = lat
      this.lng = lng
      this.pos = new google.maps.LatLng(lat, lng)
      this.html = html
    }

    HTMLMarker.prototype = new google.maps.OverlayView()
    HTMLMarker.prototype.onRemove = function() {}

    //init your html element here
    HTMLMarker.prototype.onAdd = function() {
      this.div = document.createElement('DIV')
      this.div.className = 'container__marker--html'
      this.div.style.position = 'absolute'
      this.div.innerHTML = this.html

      var panes = this.getPanes()
      panes.overlayImage.appendChild(this.div)
    }

    HTMLMarker.prototype.draw = function() {
      var overlayProjection = this.getProjection()
      var position = overlayProjection.fromLatLngToDivPixel(this.pos)
      var panes = this.getPanes()
      this.div.style.left = position.x + 'px'
      this.div.style.top = position.y + 'px'
    }

    // Add markers.
    map.markers = []
    $markers.each(function() {
      initMarker($(this), map, isFilter, HTMLMarker)
    })

    if (map.markers.length > 1 && !isFilter) {
      // Cluster the markers
      // map.cluster = markerCluster(map.markers, map)

      // Default Marker Filtering
      filterMarkers('marker', map)
    }

    // Center map based on markers.
    centerMap(map)

    // Return map instance.
    return map
  }

  /**
   * initMarker
   *
   * Creates a marker for the given jQuery element and map.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @param   object The map instance.
   * @return  object The marker instance.
   */
  function initMarker($marker, map, isFilter = false, HTMLMarker) {
    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var categories;
    var customIcon = $marker.data('icon') ? $marker.data('icon') : null;
    var useIcon = null;  // Default to null
    var isVisible = true;
    let htmlMarker = $marker.data('html-marker');
    var latLng = {
        lat: parseFloat(lat),
        lng: parseFloat(lng),
    };

    if (!isFilter) {
        // Get categories from classes
        categories = $marker.attr('class').split(/\s+/);
        categories = toArray(categories);
    } else {
        // Get categories from data attribute
        categories = $marker.data('category');
    }

    if (htmlMarker) {
        // Create new custom HTML marker element
        let customMarker = new HTMLMarker(lat, lng, htmlMarker);
        customMarker.setMap(map);

        // Add a normal marker to the markers array so that the map centers correctly
        customMarker = new google.maps.Marker({
            position: latLng,
            category: categories,
            map: map,
            visible: false, // hide the marker so only the custom HTML marker shows
        });

        map.markers.push(customMarker);
    } else {
        // Custom Icons
        if (isFilter && categories !== 'development') {
            var iconUrl = $marker.data('icon');
            if (iconUrl) {
                var categoryIcon = new google.maps.MarkerImage(
                    iconUrl,
                    null,
                    null,
                    new google.maps.Point(17, 45),
                    new google.maps.Size(52, 45)
                );
                isVisible = false;
                useIcon = categoryIcon;
            }
        } else if (customIcon) {
            var liveIcon = new google.maps.MarkerImage(
                customIcon,
                null,
                null,
                new google.maps.Point(17, 45),
                new google.maps.Size(52, 45)
            );
            useIcon = liveIcon;
        }

        // Create marker instance with or without custom icon.
        var markerOptions = {
            position: latLng,
            category: categories,
            visible: isVisible,
            map: map,
        };

        if (useIcon) {
            markerOptions.icon = useIcon;  // Only set icon if valid
        }

        var marker = new google.maps.Marker(markerOptions);

        // Append to reference for later use.
        map.markers.push(marker);

        // If marker contains HTML, add it to an infoWindow.
        if ($marker.html()) {
            // Create info window.
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html(),
            });

            // Show info window when marker is clicked.
            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open(map, marker);
            });
        }
    }
}

  /**
   * centerMap
   *
   * Centers the map showing all markers in view.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   object The map instance.
   * @return  void
   */
  function centerMap(map) {
    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds()
    map.markers.forEach(function(marker) {
      if (marker.getVisible()) {
        bounds.extend({
          lat: marker.position.lat(),
          lng: marker.position.lng(),
        })
      }

      if (marker.category.includes('sales-office')) {
        bounds.extend(marker.getPosition())
      }
    })

    // Case: Single marker.
    if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter())

      // Case: Multiple markers.
    } else {
      // Cluster the markers
      // markerCluster(map.markers, map)

      // Code to not zoom in too far on one marker
      if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
        var extendPoint1 = new google.maps.LatLng(
          bounds.getNorthEast().lat() + 0.01,
          bounds.getNorthEast().lng() + 0.01
        )
        var extendPoint2 = new google.maps.LatLng(
          bounds.getNorthEast().lat() - 0.01,
          bounds.getNorthEast().lng() - 0.01
        )
        bounds.extend(extendPoint1)
        bounds.extend(extendPoint2)
      }

      // Fit the map to bounds
      map.fitBounds(bounds)
    }
  }

  function filterMarkers(inputCategory = 'mix', map) {
    var bounds = new google.maps.LatLngBounds()

    for (i = 0; i < map.markers.length; i++) {
      marker = map.markers[i]

      // If the marker is a sales office, skip this logic for that marker
      if (marker.category.includes('sales-office')) {
        bounds.extend(marker.getPosition())
      } else {
        // Check the marker.category to see if input is in array
        if (marker.category.includes(inputCategory)) {
          marker.setVisible(true)
          bounds.extend(marker.getPosition())
        } else {
          marker.setVisible(false)
        }
      }
      // Fit map to bounds
      console.log(bounds)
      map.fitBounds(bounds)
    }

    var visibleMarkers = []

    if (map.markers) {
      for (i in map.markers) {
        if (map.markers[i].getVisible() == true) {
          visibleMarkers.push(map.markers[i])
        }

        if (map.markers[i].category.includes('sales-office')) {
          visibleMarkers.push(map.markers[i])
        }
      }
    }
    // map.cluster.clearMarkers()
    // map.cluster.addMarkers(visibleMarkers)
  }

  function filterMarkersShow(filter, map) {
    var bounds = map.getBounds()
    for (i = 0; i < map.markers.length; i++) {
      marker = map.markers[i]
      if (marker.category !== 'development') {
        // Check the marker.category to see if input is in array
        if (
          marker.category.includes(filter) &&
          !marker.category.includes('development')
        ) {
          marker.setVisible(true)
          bounds.extend(marker.getPosition())
        }
      }
      // Center the map
      centerMap(map)
    }
  }

  function filterMarkersHide(filter, map) {
    var bounds = map.getBounds()
    for (i = 0; i < map.markers.length; i++) {
      marker = map.markers[i]
      if (marker.category !== 'development') {
        // Check the marker.category to see if input is in array
        if (marker.category.includes(filter)) {
          marker.setVisible(false)
          bounds.extend(marker.getPosition())
        }
      }
      // Center the map
      centerMap(map)
    }
  }

  function markerCluster(markers, map) {
    var mcOptions = {
      gridSize: 32,
      maxZoom: 15,
      styles: [
        {
          url: clusterIconUrl,
          height: 45,
          width: 64,
          // anchorText: [0, 35],
          anchor: [0, 12],
          textColor: 'white',
        },
      ],
    }
    return (clusterer = new MarkerClusterer(map, markers, mcOptions))
  }

  function toArray(obj) {
    var array = []
    // iterate backwards ensuring that length is an UInt32
    for (var i = obj.length >>> 0; i--; ) {
      array[i] = obj[i]
    }
    return array
  }

  // Render maps on page load.
  $(document).ready(function() {
    $('.acf-map').each(function() {
      const developmentList = document.getElementById('development-list')
      const mixControls = document.getElementById('mix-controls')
      var map
      var mixer
      // Check to see if Google Maps API has loaded
      if (typeof google === 'object' && typeof google.maps === 'object') {
        map = initMap($(this))

        if ($('.template--clean').length > 0) {
          var attrs = {}

          $.each($('button.open__contact')[0].attributes, function(idx, attr) {
            attrs[attr.nodeName] = attr.nodeValue
          })

          $('button.open__contact').replaceWith(function() {
            return $('<a />', attrs).append($(this).contents())
          })

          let link = $(
            '.development__button-container a.contrast--light-1'
          ).attr('href')

          $('a.open__contact').attr('href', link)

          $('.template--clean')
            .find('a')
            .attr('target', '_blank')
        }
      }

      // Check that both elements exist to avoid errors & only load on developments archive page
      if (developmentList && mixControls) {
        var findActiveFilter = $('#mix-controls .mixitup-control-active')
        var defaultFilterClass
        if (findActiveFilter.data('filter') == 'all') {
          defaultFilterClass = 'mix'
        } else {
          defaultFilterClass = findActiveFilter.data('filter').substring(1)
        }

        filterMarkers(defaultFilterClass, map)

        // If the mix control container has a data-default-filter set
        if (mixControls.dataset.defaultFilter) {
          // Initialise mixitup with default load of the data-default-filter value
          mixer = mixitup(developmentList, {
            load: {
              filter: mixControls.dataset.defaultFilter,
            },
          })
          // Then filter the map markers to the same
          if (map) {
            filterMarkers(mixControls.dataset.defaultFilter.substring(1), map)
          }
        } else {
          // Initialise mixitup for all developments
          mixer = mixitup(developmentList, {})
        }
        // Add a mix control click listener
        developmentList.addEventListener('mixClick', function(event) {
          // Grab the filter class of whatever has been clicked
          var filterClass = event.detail.originalEvent.target.dataset.filter
            ? event.detail.originalEvent.target.dataset.filter
            : event.detail.originalEvent.target.parentElement.dataset.filter
          // Then update URL
          var urlPath = window.location.pathname
          var urlPrefix = urlPath.split('find-a-home')
          if (filterClass == 'all') {
            filterClass = 'marker'
            window.history.replaceState(
              null,
              null,
              urlPrefix[0] + 'find-a-home/'
            )
          } else {
            // Remove the leading . from the class name
            filterClass = filterClass.substring(1)
            var urlArea = filterClass.split('harron_areas-')
            window.history.replaceState(
              null,
              null,
              urlPrefix[0] + 'find-a-home/' + urlArea[1]
            )
          }
          if (map) {
            filterMarkers(filterClass, map)
          }
        })
      }
    })
    if ($('.filter-map').length > 0) {
      $('.filter-map').each(function() {
        // Run code for filter map only
        if (typeof google === 'object' && typeof google.maps === 'object') {
          map = initMap($(this), true)
        }
        $('#amenitity-filters input').change(function() {
          if (this.checked) {
            filterMarkersShow($(this).data('marker-filter'), map)
          } else {
            filterMarkersHide($(this).data('marker-filter'), map)
          }
        })
      })
    }
  })
})(jQuery)
